function CardHead({ title, value }) {
  return (
    <div className="mt-8 flex justify-between">
      <span className="text-lg font-medium  text-neutral-500">{title}</span>
      <span className="text-xl font-bold  text-neutral-700">{value}</span>
    </div>
  );
}

export default CardHead;
